import { render } from "./Addition_social.vue?vue&type=template&id=4787eb14&scoped=true"
import script from "./Addition_social.vue?vue&type=script&lang=js"
export * from "./Addition_social.vue?vue&type=script&lang=js"

import "./Addition_social.vue?vue&type=style&index=0&id=4787eb14&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4787eb14"]])